// extracted by mini-css-extract-plugin
export default {"root":"jstQkKWg","container":"s4HCSlFB","tab":"IvshncUU","active":"EAn987fI","icon":"SLRr8o51","label":"gtwxt20E"};